import Vue from 'vue';
import Vuex from 'vuex';

import identity from './modules/identity';
import workflow from './modules/workflow';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    identity,
    workflow
  }
});
